import { Helper } from "@nolimitcity/promo-panel/bin/utils/Helper";
import { ASMainGamePickOptions, WINTYPE } from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import { BackgroundNames } from "./abstracts/types/enums";
import { playSound } from "./abstracts/utils/SoundUtils";
import { UCSoundNames } from "./game/assetsLoader/UCAssetsNames";
import { UCGameData } from "./game/types/UCInterfaces";
import { AbstractGameMode } from "./abstracts/flow/AbstractGameMode";
import { UgliestCatch } from "./game/UgliestCatch";
import UCReel from "./game/modules/Reels/UCReel";
import { EventsManager } from "./abstracts/events/EventsManager";
import { UCEvents } from "./game/types/UCEnums";


export class UCPromoPanelConfig implements PromoPanelGameConfiguration {
    private gameReels: UCReel[];

    constructor() {
        this.gameReels = [];

    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: `Ugliest Catch`,
            hasActionSpin: true,
            mainGame: {
                header: () => `xBET`,
                options: [
                    { name: `NORMAL`, id: 0, image: `NORMAL.png` },
                    { name: `BOOSTED_BET`, id: 1, image: `BOOSTED_BET.png` }
                ],
                type: ASMainGamePickOptions.BOOSTED_BET
            },
            graphics: { backgroundTextureName: <string>BackgroundNames.NORMAL },
            getParsedData: (response: UCGameData, bet: number, prevResponse: UCGameData): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    totalSpinWinnings: response.totalSpinWinnings,
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank

                };
                return parsedData;
            }
        };
    }

    private isFreeSpinTriggered(response: UCGameData): boolean {
        return response.mode === AbstractGameMode.NORMAL && (response.nextMode === AbstractGameMode.FREESPIN || response.nextMode === AbstractGameMode.SUPER_FREESPIN);
    }

    private isBigWin(response:UCGameData): boolean {
        let win = response.totalSpinWinnings;

        if (response.wasFeatureBuy){
            const betPrice:number = UgliestCatch.model.getBetPrice();
            let winRatio: number = Helper.ceilToDecimals((win / betPrice), 4);
            return winRatio >= 1;
        }


        let winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        return winRatio >= 15;
    }

    private getFeatureName(response: UCGameData): string {
        if (response.mode === AbstractGameMode.NORMAL &&
            response.nextMode !== AbstractGameMode.NORMAL
        ) {
            EventsManager.trigger(UCEvents.CLOSE_BLOCKERS);
        }

        if ((response.mode == AbstractGameMode.FREESPIN) || response.nextMode == AbstractGameMode.FREESPIN) {
            let spinsLevel: number = response.extraPositionsOpen.filter((item) => item).length;
            if (spinsLevel >= 4) {
                return `HAWG SPINS`;
            }
            return `LUNKER SPINS`;
        }

        if ((response.mode == AbstractGameMode.SUPER_FREESPIN) || response.nextMode == AbstractGameMode.SUPER_FREESPIN){
            return `HONEY HOLE SPINS`;
        }
        return response.mode;
    }

    private isRoundComplete(response: UCGameData): boolean {
        return  ([AbstractGameMode.FREESPIN,AbstractGameMode.SUPER_FREESPIN, AbstractGameMode.NORMAL].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: UCGameData): boolean {
        return (response.nextMode === AbstractGameMode.NORMAL) && (response.nextMode === AbstractGameMode.FREESPIN || response.nextMode === AbstractGameMode.SUPER_FREESPIN);
    }

    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if (trigger == ActionSpinSound.WIN){
            playSound({ name: <string>UCSoundNames.AS_WIN });

        }
        else if (trigger == ActionSpinSound.BIG_WIN) {
            playSound({ name: <string>UCSoundNames.AS_WIN_BIG });
        }
    }

}